<template>
  <div style="height: 100vh">
    <CRow class="h-100" alignHorizontal="center" alignVertical="center">
      <CCol class="text-center">
        <LoadingSpinner />
        <div class="h5 mt-5 text-primary" style="display: inline-block">Waiting for plan setup</div>
        <!-- <div class="h5 text-primary text-left pl-1" style="display: inline-block; width: 50px">{{ dots }}</div> -->
      </CCol>
    </CRow>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue'

export default {
  components: {
    LoadingSpinner,
  },
}
</script>
